import React from 'react';
import { ENTITY } from '../utils/constants';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    if (typeof window !== 'undefined' && window.gtag) {
      window.gtag('event', 'error_boundary', {
        error_message: error.message,
        component_stack: info.componentStack,
      });
    }
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
  };

  handleGoHome = () => {
    this.setState({ hasError: false, error: null });
    if (typeof window !== 'undefined') {
      window.location.href = '/';
    }
  };

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback;

      return (
        <div
          style={{
            minHeight: '100vh',
            background: 'var(--bg-page, #F5F3ED)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '20px',
            fontFamily:
              "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, sans-serif",
          }}
        >
          <div
            style={{
              background: '#ffffff',
              borderRadius: '24px',
              padding: '48px',
              maxWidth: '480px',
              width: '100%',
              textAlign: 'center',
              boxShadow: '0 12px 32px rgba(0, 0, 0, 0.1)',
            }}
          >
            <div
              style={{
                width: '80px',
                height: '80px',
                borderRadius: '50%',
                background: 'var(--primary, #6366F1)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                margin: '0 auto 24px',
                fontSize: '36px',
                color: '#ffffff',
                lineHeight: 1,
              }}
            >
              !
            </div>

            <h1
              style={{
                fontSize: '24px',
                fontWeight: 700,
                color: '#333',
                marginBottom: '12px',
              }}
            >
              {ENTITY.labels.errorTitle}
            </h1>

            <p
              style={{
                fontSize: '16px',
                lineHeight: 1.6,
                color: '#666',
                marginBottom: '8px',
              }}
            >
              {ENTITY.labels.errorMessage}
            </p>

            <p
              style={{
                fontSize: '14px',
                color: '#999',
                marginBottom: '32px',
              }}
            >
              {ENTITY.labels.errorLogged}
            </p>

            <div
              style={{
                display: 'flex',
                gap: '12px',
                justifyContent: 'center',
                flexWrap: 'wrap',
              }}
            >
              <button
                onClick={this.handleReset}
                style={{
                  padding: '14px 28px',
                  background: 'var(--primary, #6366F1)',
                  color: '#ffffff',
                  border: 'none',
                  borderRadius: '24px',
                  fontSize: '15px',
                  fontWeight: 600,
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 4px 12px rgba(99, 102, 241, 0.3)',
                }}
                onMouseOver={(e) =>
                  (e.currentTarget.style.transform = 'translateY(-2px)')
                }
                onMouseOut={(e) => (e.currentTarget.style.transform = 'none')}
              >
                {ENTITY.labels.errorRetry}
              </button>

              <button
                onClick={this.handleGoHome}
                style={{
                  padding: '14px 28px',
                  background: '#ffffff',
                  color: '#666',
                  border: '2px solid #e0e0e0',
                  borderRadius: '24px',
                  fontSize: '15px',
                  fontWeight: 600,
                  cursor: 'pointer',
                  transition: 'all 0.3s ease',
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.borderColor = 'var(--primary, #6366F1)';
                  e.currentTarget.style.color = 'var(--primary, #6366F1)';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.borderColor = '#e0e0e0';
                  e.currentTarget.style.color = '#666';
                }}
              >
                {ENTITY.labels.errorGoHome}
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
